<template>
  <router-view />
</template>

<script>
export default {
  name: 'Administrations'
}
</script>

<style scoped>

</style>
